import React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import styled from 'styled-components'
import EmployeeOnboardingView from 'features/Onboarding/employee/EmployeeOnboardingView'
import { isOnboarding } from 'features/Onboarding/helperFunctions'
import CardCreationBanner from '../components/CardCreationBanner'
import MyWalletCard from '../components/MyWalletCard'
import ThisMonthCard from '../components/ThisMonthCard'
import MyProgramsCard from '../components/MyProgramsCard'

const Container = styled.div`
  padding: 2rem;
`

const LowerSection = styled.div`
  margin-top: 1.5rem;
`

const EmployeeDashboardView = React.memo(() => {
  const onboarding = useSelector((state: AppState) => state.onboarding)

  if (isOnboarding(onboarding)) {
    return <EmployeeOnboardingView />
  }

  return (
    <Container>
      <CardCreationBanner />
      <ThisMonthCard />
      <LowerSection>
        <MyWalletCard />
      </LowerSection>
      <LowerSection>
        <MyProgramsCard />
      </LowerSection>
    </Container>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  EmployeeDashboardView.displayName = 'EmployeeDashboardView'
}

export default EmployeeDashboardView
